import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlHelper } from '../api-url-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { HttpClientHelper } from '../http-helper';
import { map, publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class SearchService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _videoTransFormer: VideoTransFormer,
        private _httpClientHelper: HttpClientHelper
    ) { }

    trendData : Observable<any>;
    getTrendingSearchList(index = 0): Observable<any[]> {


        if(!this.trendData)
        {
            const apiURL = this._apiUrlHelper.urlBuilder('trending-searches', {});
            this.trendData =
            this._httpClientHelper.getWithCache(apiURL)
           .pipe(
               publishReplay(1), // this tells Rx to cache the latest emitted
               refCount()
               );
            setTimeout(()=>{this.trendData = null;}, 30 * 60 * 1000);
        }
        return this.trendData.pipe(map(res=>{
                return res!=null && res.length>= index ? res[index].map(item => {
                    return {
                        title: item.title,
                        count: item.num,
                    };
                }):[];
            })
        );

    }

    getTags(cid):Observable<any>
    {
        const apiURL = this._apiUrlHelper.urlBuilder('tag-list',{
            cid :cid
        })

        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
            return res;
        }));
    }

    /*
    // 获取搜索导航
    */
    getSearchTree(cid):Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('search-tree',{
            cid :cid
        })

        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
            return res;
        }));
    }
    search(params,isNormal=true): Observable<any> {
        // 把电影分类下的动画电影转换为动漫分类
        // if (params.cid === '0,1,3,113') {
        //     params.cid = '0,1,6,57';
        // }
        var cid = params.cid === -1 ? '' : (params.cid ? params.cid : '');
        if(cid == "game")
        {
            cid ="games";
        }
        const apiURL = this._apiUrlHelper.urlBuilder('search',
            {
                tags: params.keyword ? params.keyword : '',
                orderby: params.orderBy ? params.orderBy : 0,
                page: params.page ? params.page : 1,
                size: params.size ? params.size : 10,
                desc: params.desc ? 1 : '0',
                cid: cid,
                label: params.tag ? ((params.tag === '-1' || params.tag === -1) ? ''
                    : params.tag)
                    : '',
                year: params.year ? ((params.year === '-1' || params.year === -1) ? '' : params.year) : '',
                language: params.language ? ((params.language === '-1' || params.language === -1) ? '' : params.language) : '',
                region: params.region ? ((params.region === '-1' || params.region === -1) ? '' : params.region) : '',
                isserial: params.status ? ((params.status === '-1' || params.status === -1) ? '-1' : params.status) : -1,
                isIndex: params.isRecommended ? ((params.isRecommended === '-1' || params.isRecommended === -1) ? '-1'
                    : params.isRecommended)
                    : -1,
                isfree: params.isFree ? ((params.isFree === '-1' || params.isFree === -1) ? '-1'
                    : params.isFree)
                    : -1,
                vipResource: params.vipResource ? params.vipResource : '',
                isShortVideo: params.isShortVideo,
            },isNormal?"":"NEWS_ENDPOINT");
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
            if(isNormal)
            {
                return {
                    count: res[0].recordcount,
                    maxpage: res[0].maxpage,
                    items: res[0].result
                };
            }
            else{
                return {
                    count: res[0].recordcount,
                    maxpage: res[0].maxpage,
                    items: res[0].result.map(item => {
                        return this._videoTransFormer.transformFromList(item);
                    })
                };
            }

            }));
    }

    solrSearch(params): Observable<any> {
        var orderBy = "";
        if(params.orderBy ==0)
        {
            orderBy = params.orderBy +"";
        }
        else if(params.orderBy)
        {
            orderBy = params.orderBy +"";

        }
        else
        {
            orderBy = "4";
        }
        // console.log(params.keyword)
        // console.log(encodeURIComponent(params.keyword), "****")
        const apiURL = this._apiUrlHelper.urlBuilder('solr-search',
            {
                tags: params.keyword ? params.keyword : '',
                star: params.star ? params.star : '',
                director: params.director ? params.director : '',
                orderby:orderBy,
                page: params.page ? params.page : 1,
                size: params.size ? params.size : 10,
                desc: params.desc ? 1 : 0,
                cid: params.cid === -1 ? '' : (params.cid ? params.cid : ''),
                year: params.year ? ((params.year === '-1' || params.year === -1) ? '' : params.year) : '',
                language: params.language ? ((params.language === '-1' || params.language === -1) ? '' : params.language) : '',
                region: params.region ? ((params.region === '-1' || params.region === -1) ? '' : params.region) : '',
                isserial: params.status ? ((params.status === '-1' || params.status === -1) ? '-1' : params.status) : -1,
                istitle:params.istitle,
                cinema: params.cinema ? params.cinema : undefined,
                vipResource: params.vipResource ? params.vipResource : '',
            });
        // console.log(apiURL)
        // return this._httpClientHelper.get(apiURL)
        const body = {
            tags: params.keyword ? params.keyword : '',
        }
        return this._httpClientHelper.post(apiURL, body, null)
        .pipe(map((res) => {
                if (res.length) {
                    return {
                        count: res[0].recordcount,
                        items: res[0].result.map(item => {
                            return this._videoTransFormer.transformFromList(item);
                        })
                    };
                } else {
                    return {
                        count: 0,
                        items: []
                    };
                }
            }));
    }

    userSearch(params): Observable<any> {
        let orderBy = "";
        if (params.orderBy === 0) {
            orderBy = params.orderBy + "";
        } else if (params.orderBy) {
            orderBy = params.orderBy + "";
        } else {
            orderBy = "4";
        }
        const apiURL = this._apiUrlHelper.urlBuilder('user-search',
            {
                // tags: params.keyword ? encodeURIComponent(params.keyword) : '',
                orderby: orderBy,
                page: params.page ? params.page : 1,
                size: params.size ? params.size : 10,
                desc: params.desc ? 1 : 0,
                cinema: params.cinema ? params.cinema : undefined,
            });
        // return this._httpClientHelper.get(apiURL)
        const body = {
            tags: params.keyword ? params.keyword : '',
        }
        return this._httpClientHelper.post(apiURL, body, null)
        .pipe(
            map((res) => {
                if (res.length) {
                    return {
                        count: res[0].recordNum,
                        items: res[0].list.map(item => {
                            return item;
                        })
                    };
                } else {
                    return {
                        count: 0,
                        items: []
                    };
                }
            })
        );
    }



    getSearchFilters() {
        const apiURL = this._apiUrlHelper.urlBuilder('search-filters', {});
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
                return {
                    region: res[0].region.map((i, index) => {
                        return {
                            cid: '',
                            id: i.link,
                            link: i.link,
                            slug: '',
                            title: i.title
                        };
                    }),
                    language: res[0].language.map((i, index) => {
                        return {
                            cid: '',
                            id: i.link,
                            link: i.link,
                            slug: '',
                            title: i.title
                        };
                    }),
                    year: res[0].year.map((i, index) => {
                        return {
                            cid: '',
                            id: i.link,
                            link: i.link,
                            slug: '',
                            title: i.title
                        };
                    }),
                    status: res[0].isSerial.map(i => {
                        return {
                            cid: '',
                            id: i.link,
                            link: i.link,
                            slug: '',
                            title: i.title
                        };
                    })
                };
            }));
    }

    getSearchSuggestList(): Observable<any[]> {
        return this.getTrendingSearchList(1);
        // const apiURL = this._apiUrlHelper.urlBuilder('suggested-searches', {});
        // return this._httpClientHelper.get(apiURL)
        // .pipe(map(items => {
        //         return items.map(item => {
        //             return {
        //                 title: item.title,
        //                 count: item.num,
        //             };
        //         });
        //     }));
    }

    albumSearch(params): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('ablum-search',
            {
                page: params.page ? params.page : 1,
                size: params.size ? params.size : 10,
                photoType: params.type === 'album' ? 0 : 1,
            });
        const body = {
            tag: params.label ? params.label : '',
            key: params.keyword ? params.keyword : '',
        }
        return this._httpClientHelper.post(apiURL, body, null)
        .pipe(
            map((res) => {
                if (res.length) {
                    return {
                        count: res[0].recordCount,
                        items: res[0].list.map(item => {
                            return item;
                        })
                    };
                } else {
                    return {
                        count: 0,
                        items: []
                    };
                }
            })
        );
    }

    getAlbumLabels(): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('get-ablum-labels', {});
        return this._httpClientHelper.get(apiURL)
        .pipe(
            map(items => {
                return items.map((item, index) => {
                    return {
                        title: item,
                        id: index,
                    };
                });
            })
        );
    }
}
